<template>
  <div id="rfid-enrollment" class="visit-register" v-if="userDetails">
    <div class="visit-register-header">
      <div class="logo-2">
        <img
          v-if="userDetails.entity.logo"
          class="img-fluid"
          :src="userDetails.entity.logo"
          alt="-visipoint-logo"
        />
        <img
          v-else
          class="img-fluid"
          src="@/assets/images/logo-lg.svg"
          alt="-visipoint-logo"
        />
      </div>

      <div class="form-title-con">
        <p class="form-title">Hello {{ userDetails.user.first_name }},</p>
      </div>

      <p class="company-pass2" v-if="isDeactivated">
        “{{ userDetails.entity.name }}” has created a Local QuickPass for you.
      </p>
      <p
        class="company-pass"
        style="margin-inline-start: 125px; margin-inline-end: 100px"
        v-else-if="passportCreated"
      >
        “{{ userDetails.entity.name }}” has created a VisiPoint Passport account
        for you.
      </p>
      <p class="company-pass" v-else>
        Please check the instructions below to learn how to enrol your access
        card in “{{ userDetails.entity.name }}” company:
      </p>

      <p class="noqr-sub-title" v-if="isDeactivated || passportCreated">
        Please check the instructions below to learn how to enrol your access
        card in “{{ userDetails.entity.name }}” company:
      </p>

      <div class="qrgray-con" v-if="isDeactivated">
        <div class="qrblack-outline">
          <img :src="userDetails.localQr" alt="QR Code" style="padding: 8px" />
        </div>
        <div class="download-link">
          <a
            class="download-pdf"
            :href="userDetails.pdfUrl"
            @click.prevent="downloadPDF(userDetails.pdfUrl)"
            >Download as PDF</a
          >
        </div>
      </div>
      <div class="qrgray-con" v-else>
        <div class="qrblack-outline">
          <img
            :src="userDetails.user.passport_qr"
            alt="QR Code"
            style="padding: 8px"
          />
        </div>
        <div class="download-link">
          <a
            class="download-pdf"
            :href="userDetails.pdfUrl"
            @click.prevent="downloadPDF(userDetails.pdfUrl)"
            >Download as PDF</a
          >
        </div>
      </div>
    </div>

    <div class="main-content">
      <div class="content-message">
        Scan your access card on the terminal, then scan the above
        {{ !isDeactivated ? "Passport" : "Local" }}
        QuickPass to enrol your access card.
      </div>
    </div>

    <template v-if="passportCreated">
      <div class="access-withCredentials">
        <div class="custom-line"></div>
        <p class="passport-access">
          You can access your Passport Account using the following credentials:
        </p>
        <p class="user-name">Username:</p>
        <div class="show-userName-con">
          <p class="show-userName">{{ userDetails.user.phone }}</p>
        </div>
        <p class="user-password">Temporary password:</p>
        <div class="show-userPassword-con">
          <p class="show-userPassword">{{ decryptedPassword }}</p>
        </div>
        <p class="change-password">
          Please log in and change your password to something memorable.
        </p>
      </div>
      <div class="check-location">
        <div class="custom-line"></div>
        <p class="check-location-qr">
          Check in at any VisiPoint location using your personal QR code, saving
          you time on entry. Scanning your QR code at any VisiPoint site will
          transfer your data onto that site in order to sign in.
        </p>
        <p class="download-qa">
          Why not download the QR code to keep it handy.
        </p>
      </div>
      <div class="passport-login">
        <div class="custom-line"></div>
        <p class="passport-login-txt">
          You can log in to your VisiPoint Passport account at any time by
          clicking the button below.
        </p>
        <button class="btn btn-primary" @click="redirectTo()">
          {{ $t('preRegisteration.go_to_passport') }}
        </button>
      </div>
    </template>

    <div class="final-txt">
      <p class="regards-msg">Regards,</p>
      <p class="company-name">{{ userDetails.entity.name }}</p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import { saveAs } from "file-saver";

var CryptoJS = require("crypto-js");
var CryptoJSAesJson = {
  stringify: function (cipherParams) {
    var j = {
      ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64),
    };
    if (cipherParams.iv) j.iv = cipherParams.iv.toString();
    if (cipherParams.salt) j.s = cipherParams.salt.toString();
    return JSON.stringify(j);
  },
  parse: function (jsonStr) {
    var j = JSON.parse(jsonStr);
    var cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(j.ct),
    });
    if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);
    if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);
    return cipherParams;
  },
};

export default {
  components: {},
  name: "RFIDEnrollment",
  data() {
    return {
      user_id: null,
      fullName: null,
      noPassport: false,
      hasPassport: false,
      isDeactivated: false,
      passportCreated: false,
      userDetails: null,
    };
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
    ...mapGetters("users", ["getModalState", "getLoading"]),
    decryptedPassword() {
      if (this.userDetails && this.userDetails.encrypted_password) {
        const key = process.env.VUE_APP_PASSPORT_KEY;
        let decryptedPw = CryptoJS.AES.decrypt(
          atob(this.userDetails.encrypted_password),
          key,
          {
            format: CryptoJSAesJson,
          }
        ).toString(CryptoJS.enc.Utf8);
        return decryptedPw.replace(/"/g, "");
      }

      return "";
    },
  },
  methods: {
    ...mapActions("users", ["resetLoading"]),
    ...mapActions("setting", ["verifyRFIDCode"]),
    downloadPDF(url) {
      axios.get(url, { responseType: "blob" }).then((response) => {
        saveAs(response.data, "QR Code.pdf");
      });
    },

    redirectTo() {
      window.location.href = this.userDetails.magicLink;
    },
  },
  async beforeMount() {
    // this.resetLoading();
    console.log("code", this.$route.params.code);
    const result = await this.verifyRFIDCode({ code: this.$route.params.code });
    console.log("result", result);
    this.userDetails = result.data.data;
    if (
      this.userDetails.user.deactivate_date &&
      !this.userDetails.user.is_active
    )
      this.isDeactivated = true;
    else if (this.userDetails.magicLink) this.passportCreated = true;
  },
  mounted() {},
};
</script>

<style lang="scss">
div#rfid-enrollment {
  width: 710px;
  background: #ffffff;
  box-shadow: 0px 1px 40px 3px rgba(0, 0, 0, 0.05);
  border-radius: 26px;
  margin: 72px auto 0px auto;
  padding-bottom: 56px;
  .visit-register-header {
    .logo-2 {
      margin: auto;
      width: 126px;
      img.img-fluid {
        width: 126px;
        height: 24px;
        margin-top: 56px;
        margin-bottom: 48px;
      }
    }
  }

  .form-title-con {
    width: 710px;
    display: flex;
    align-items: center;
    justify-content: center;
    p.form-title {
      font-weight: 700;
      font-size: 30px;
      line-height: 36px;
      display: flex;
      align-items: center;
      text-align: center;
      color: #000000;
      // width: 164px;
      margin: 0px auto 40px auto;
    }
  }

  p.company-pass {
    font-weight: 700;
    font-size: 16px;
    line-height: 30px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.25px;
    color: #000000;
    width: 543px;
    margin: 0px auto 48px auto;
  }
  p.company-pass2 {
    font-weight: 700;
    font-size: 16px;
    line-height: 30px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.25px;
    color: #000000;
    width: 413px;
    margin: 0px auto 48px auto;
  }
  p.noqr-sub-title {
    font-weight: 400;
    font-size: 16px;
    line-height: 30px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.25px;
    color: #787878;
    width: 543px;
    margin: 0px auto 48px auto;
  }
  .qrgray-con {
    width: 208px;
    height: 231px;
    background: #f3f3f3;
    border: 2.5px solid #f3f3f3;
    border-radius: 8px;
    margin: 0px auto 48px auto;
    .qrblack-outline {
      width: 143px;
      height: 143px;
      border: 6.5px solid #000000;
      border-radius: 11px;
      margin: 37px auto 8px auto;
    }
    .download-link {
      width: 117px;
      margin: 0px auto 26px auto;
      a.download-pdf {
        font-weight: 700 !important;
        font-size: 14px !important;
        line-height: 17px !important;
        text-align: center;
        color: #000000 !important;
        // margin: 0px auto 26px auto;
      }
    }
  }
  .main-content {
    margin-inline-start: 0px !important;
    .content-message {
      font-weight: 400;
      font-size: 16px;
      line-height: 30px;
      display: flex;
      align-items: center;
      text-align: center;
      letter-spacing: 0.25px;
      color: #787878;
      width: 518px;
      margin: 0px auto 40px auto;
    }
  }
  .access-withCredentials {
    .custom-line {
      height: 1px;
      background: #707070;
      width: 615px;
      opacity: 0.15;
      margin: 0px auto 40px auto;
    }
    .passport-access {
      font-weight: 400;
      font-size: 16px;
      line-height: 30px;
      /* identical to box height, or 188% */
      width: 501px;
      margin: 0px auto 40px auto;
      display: flex;
      align-items: center;
      letter-spacing: 0.25px;

      color: #787878;
    }
    p.user-name {
      font-weight: 700;
      font-size: 16px;
      line-height: 30px;
      /* identical to box height, or 188% */

      display: flex;
      align-items: center;
      letter-spacing: 0.25px;
      margin: 0px auto 16px auto;
      /* Main Button */
      width: 80px;
      color: #103f5e;
    }
    .show-userName-con {
      width: 276px;
      height: 36px;
      margin: 0px auto 24px auto;
      background: #f2f2f2;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 7px;
      p.show-userName {
        font-weight: 700;
        font-size: 16px;
        line-height: 30px;
        /* or 188% */
        margin: 10px 11px;
        letter-spacing: 0.25px;

        color: #000000;
      }
    }
    p.user-password {
      font-weight: 700;
      font-size: 16px;
      line-height: 30px;
      /* identical to box height, or 188% */

      display: flex;
      align-items: center;
      letter-spacing: 0.25px;
      margin: 0px auto 16px auto;
      /* Main Button */
      width: 157px;
      color: #103f5e;
    }
    .show-userPassword-con {
      width: 165px;
      height: 36px;
      margin: 0px auto 40px auto;
      background: #f2f2f2;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 7px;
      p.show-userPassword {
        font-weight: 700;
        font-size: 16px;
        line-height: 30px;
        /* or 188% */
        margin: 10px 11px;
        letter-spacing: 0.25px;

        color: #000000;
      }
    }
    .change-password {
      font-weight: 400;
      font-size: 16px;
      line-height: 30px;
      /* identical to box height, or 188% */
      width: 470px;
      margin: 0px auto 40px auto;
      display: flex;
      align-items: center;
      letter-spacing: 0.25px;

      color: #787878;
    }
  }
  .check-location {
    .custom-line {
      height: 1px;
      background: #707070;
      width: 615px;
      opacity: 0.15;
      margin: 0px auto 40px auto;
    }
    p.check-location-qr {
      font-weight: 400;
      font-size: 16px;
      line-height: 30px;
      display: flex;
      align-items: center;
      text-align: center;
      letter-spacing: 0.25px;
      color: #787878;
      width: 518px;
      margin: 0px auto 16px auto;
    }
    p.download-qa {
      font-weight: 400;
      font-size: 16px;
      line-height: 30px;
      display: flex;
      align-items: center;
      text-align: center;
      letter-spacing: 0.25px;
      color: #787878;
      width: 350px;
      margin: 0px auto 40px auto;
    }
  }
  .passport-login {
    .custom-line {
      height: 1px;
      background: #707070;
      width: 615px;
      opacity: 0.15;
      margin: 0px auto 40px auto;
    }
    .passport-login-txt {
      font-weight: 400;
      font-size: 16px;
      line-height: 30px;
      /* or 188% */
      width: 518px;
      display: flex;
      align-items: center;
      text-align: center;
      letter-spacing: 0.25px;
      margin: 0px auto 48px auto;
      color: #787878;
    }
    button.btn.btn-primary {
      background: #103f5e;
      border-radius: 18.5px;
      width: 195px;
      height: 37px;
      margin: 0px auto 48px auto;
      display: flex;
      align-items: center;
      justify-content: center;

      font-weight: 500;
      font-size: 16px;
      line-height: 17px;
      /* identical to box height, or 106% */

      text-align: center;
      letter-spacing: 0.25px;
      text-transform: uppercase;

      color: rgba(255, 255, 255, 0.87);
    }
  }
  .final-txt {
    width: 710px;
    display: grid;
    p.regards-msg {
      font-weight: 700;
      font-size: 16px;
      line-height: 30px;
      /* identical to box height, or 188% */
      // width: 64px;
      display: flex;
      align-items: center;
      letter-spacing: 0.25px;
      margin: 0px auto 8px auto;
      color: #000000;
    }
    p.company-name {
      font-weight: 700;
      font-size: 16px;
      line-height: 30px;
      /* identical to box height, or 188% */
      margin: 0px auto 0px auto;

      display: flex;
      align-items: center;
      letter-spacing: 0.25px;
      // width: 117px;
      color: #000000;
    }
  }
}
</style>
<style lang="scss">
@media (max-width: 992px) {
  div#rfid-enrollment {
    width: 390px !important;
    background: #ffffff !important;
    // box-shadow: 0px 1px 40px 3px rgba(0, 0, 0, 0.05);
    border-radius: 0px !important;
    margin: 0px auto !important;
    padding-bottom: 116px !important;
    .visit-register-header {
      .logo-2 {
        margin: auto;
        width: 126px !important;
        img.img-fluid {
          width: 126px !important;
          height: 24px !important;
          margin-top: 75px !important;
          margin-bottom: 48px !important;
        }
      }
    }
    .form-title-con {
      width: 390px !important;
      display: flex;
      align-items: center;
      justify-content: center;
      p.form-title {
        font-weight: 700 !important;
        font-size: 17px !important;
        line-height: 20px !important;
        text-align: center !important;

        color: #000000;
        // width: 164px;
        margin: 0px auto 16px auto !important;
      }
    }
    p.company-pass {
      font-weight: 700 !important;
      font-size: 14px !important;
      line-height: 24px !important;
      /* or 171% */

      display: flex;
      align-items: center;
      text-align: center;
      letter-spacing: 0.25px !important;

      color: #000000 !important;
      width: 303px !important;
      margin: 0px 44px 48px 44px !important;
    }
    .qrgray-con {
      width: 188px !important;
      height: 187px !important;
      background: #f3f3f3;
      border: 2.5px solid #f3f3f3;
      border-radius: 8px;
      margin: 0px auto 48px auto;
      .qrblack-outline {
        width: 151px !important;
        height: 151px !important;
        border: 6.5px solid #000000;
        border-radius: 11px;
        margin: 5px auto !important;
      }
      .download-link {
        width: 117px;
        margin: 5px auto 10px auto !important;
        a.download-pdf {
          font-weight: 700 !important;
          font-size: 14px !important;
          line-height: 17px !important;
          text-align: center;
          color: #000000 !important;
          // margin: 0px auto 26px auto;
        }
      }
    }
    .content-message {
      font-weight: 400 !important;
      font-size: 14px !important;
      line-height: 26px !important;
      /* or 182% */

      display: flex;
      align-items: center;
      text-align: center;
      letter-spacing: 0.25px !important;

      /* #939393 */

      color: #939393 !important;
      width: 303px !important;
      margin: 0px auto 48px auto !important;
    }
    .final-txt {
      width: 390px !important;
      display: grid;
      p.regards-msg {
        font-weight: 700;
        font-size: 16px;
        line-height: 30px;
        /* identical to box height, or 188% */
        // width: 64px;
        display: flex;
        align-items: center;
        letter-spacing: 0.25px;
        margin: 0px auto 8px auto;
        color: #000000;
      }
      p.company-name {
        font-weight: 700;
        font-size: 16px;
        line-height: 30px;
        /* identical to box height, or 188% */
        margin: 0px auto 0px auto;

        display: flex;
        align-items: center;
        letter-spacing: 0.25px;
        // width: 117px;
        color: #000000;
      }
    }
  }
}
</style>
